import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { useDynamicForm } from "@/features/forms/hooks";
import type { Answers, Form as FormType } from "@/features/forms/models";
import { filterHiddenConditionalAnswers } from "@/features/forms/utils";
import { HealthieFormField } from "@/features/intake-form/components/healthie-form/components";
import { Button, Form } from "@/shared/ui";

interface DynamicFormProps {
  onSubmit: (values: Answers) => void;
  form: FormType;
  submitLabel?: string;
}

export const DynamicForm = ({
  form,
  onSubmit,
  submitLabel = t`Submit`,
}: DynamicFormProps) => {
  const dynamicForm = useDynamicForm(form);
  const navigate = useNavigate();

  const handleSubmit = (values: Answers) => {
    onSubmit(filterHiddenConditionalAnswers(values, form.fields));
  };

  return (
    <Form.Provider {...dynamicForm}>
      <form
        onSubmit={dynamicForm.handleSubmit(handleSubmit)}
        className="flex w-full max-w-3xl flex-col gap-8 self-center"
      >
        {form.fields.map((field) => (
          <HealthieFormField key={field.id} healthieField={field} />
        ))}

        <div className="flex w-full flex-col-reverse items-center gap-y-4 sm:flex-row sm:justify-between">
          <Button
            variant="secondary"
            size="lg"
            className="w-full sm:w-fit"
            onClick={() => navigate(-1)}
          >
            {t`Back`}
          </Button>

          <Button type="submit" size="lg" className="w-full sm:w-fit">
            {submitLabel}
          </Button>
        </div>
      </form>
    </Form.Provider>
  );
};
